/* eslint-disable */
import { useMemo } from "react";

export function useThemeStyles(T, isMobile) {
  return useMemo(() => {
    // Step 17 closure: `br` and `br75` collapsed to var(--radius-sm) (3px) per
    // Stage B audit math discovery — at the canonical T.borderRadius=4, both
    // Math.round(4 * 0.67) and Math.round(4 * 0.75) round to 3px, so the
    // 67%/75% distinction was dead at the only production base. Returning the
    // var() string lets the browser resolve the CSS variable at inline-style
    // serialization (works in React-runtime; Convention #62's popup/iframe
    // literal-preservation does NOT apply to React hooks — see Step 17 commit
    // body for boundary clarification). Distinct identifiers preserved for
    // consumers; future runtime-customizable radius can reintroduce the
    // distinction in a separate refactor.
    const br   = 'var(--radius-sm)';   // was Math.round(T.borderRadius * 0.67)
    const br75 = 'var(--radius-sm)';   // was Math.round(T.borderRadius * 0.75)
    return {
      br,
      br75,
      inputSt: { width:"100%", padding:isMobile ? "var(--space-md) var(--space-lg)" : "var(--space-sm) var(--space-md)", borderRadius:br, border:`var(--border-emphasis) solid ${T.border}`, fontSize:isMobile?'var(--text-md)':'var(--text-sm)', color:T.textPrimary, background:T.cardBg, boxSizing:"border-box", outline:"none", fontFamily:T.bodyFont },
      cardSt: { background:T.cardBg, border:`var(--border-med) solid ${T.border}`, borderRadius:T.borderRadius },
      lblSt: { fontSize:'var(--text-xs)', color:T.textMuted, fontWeight:'var(--weight-bold)', display:"block", marginBottom:'var(--space-xs)', textTransform:"uppercase", letterSpacing:".05em" },
      btnP: { background:T.accent, color:T.accentText, border:"none", borderRadius:br75, padding:"var(--space-md) var(--space-xl)", cursor:"pointer", fontWeight:'var(--weight-bold)', fontSize:'var(--text-sm)', fontFamily:T.bodyFont },
      btnS: { background:"transparent", color:T.textSecondary, border:`var(--border-emphasis) solid ${T.border}`, borderRadius:br75, padding:"var(--space-md) var(--space-xl)", cursor:"pointer", fontSize:'var(--text-sm)', fontFamily:T.bodyFont },
    };
  }, [T, isMobile]);
}
